export type HomeMapMode = "explorer" | "operatorScoped";

function asRecord(v: unknown): Record<string, unknown> | null {
  return v && typeof v === "object" ? (v as Record<string, unknown>) : null;
}

function registrationChild(data: Record<string, unknown>): Record<string, unknown> | null {
  const nested = data.registration ?? data.Registration;
  return nested && typeof nested === "object" ? (nested as Record<string, unknown>) : null;
}

function boolField(o: Record<string, unknown> | null, ...keys: string[]): boolean {
  if (!o) return false;
  for (const k of keys) {
    if (o[k] === true) return true;
  }
  return false;
}

/**
 * CRM `All_Operators_Map` on Contact — per-user permission for the national Home pipeline map.
 * Replaces legacy `responder stakeholder && !operatorUser` after CRM backfill.
 */
export function parseRegistrationAllOperatorsMap(registrationProfileData: unknown | null): boolean {
  const root = asRecord(registrationProfileData);
  if (!root) return false;
  const data = asRecord(root.data) ?? root;
  const reg = registrationChild(data);
  return (
    boolField(data, "allOperatorsMap", "AllOperatorsMap") ||
    boolField(reg, "allOperatorsMap", "AllOperatorsMap")
  );
}

/** National Home pipeline map when CRM `All_Operators_Map` is true. */
export function canShowAllOperatorsExplorerMap(params: {
  registrationProfileData: unknown | null;
  profileStakeholderRaw?: string | null | undefined;
  stakeholderOverride?: string | null | undefined;
}): boolean {
  return parseRegistrationAllOperatorsMap(params.registrationProfileData);
}

export function resolveHomeMapMode(params: {
  registrationProfileData: unknown | null;
  profileStakeholderRaw?: string | null | undefined;
  stakeholderOverride?: string | null | undefined;
}): HomeMapMode {
  return canShowAllOperatorsExplorerMap(params) ? "explorer" : "operatorScoped";
}
